module.exports = __webpack_public_path__ + "img/juxue2.ff53e2ca.png";